






































import Vue from 'vue'
import Component from 'vue-class-component'
import DirectoryTable from './components/DirectoryTable.vue'
import gistApi from '@/io/apis/gist'

@Component({
  components: { DirectoryTable },
})
export default class PacksDirectory extends Vue {
  private massifPacks = []
  private massifLoading = true
  private communityPacks = []
  private communityLoading = true

  mounted(): void {
    gistApi
      .getMassifPacks()
      .then((response: any) => {
        this.massifLoading = false
        if (!response || !response.files) {
          this.massifPacks = []
        } else {
          this.massifPacks = JSON.parse(response.files['massifpacks.json'].content)
        }
      })
      .catch(err => {
        this.massifLoading = false
        console.error('There was an issue downloading the Massif content packs.', err)
      })

    gistApi
      .getCommunityPacks()
      .then((response: any) => {
        this.communityLoading = false
        if (!response || !response.files) {
          this.communityPacks = []
        } else {
          this.communityPacks = JSON.parse(response.files['communitypacks.json'].content)
        }
      })
      .catch(err => {
        this.communityLoading = false
        console.error('There was an issue downloading the Massif content packs.', err)
      })
  }
}
